module.exports = "<div class=\"content-container admin-wrapper\" *ngIf=\"menuItems\">\n  <div class=\"content-area\">\n    <router-outlet></router-outlet>\n  </div>\n  <clr-vertical-nav [clrVerticalNavCollapsible]=\"true\" [(clrVerticalNavCollapsed)]=\"collapsed\" style=\"background: #FFFFFF;\">\n    <a clrVerticalNavLink *ngFor=\"let menuItem of menuItems\" [routerLink]=\"menuItem.link\" routerLinkActive=\"active\" style= \"margin-left: 10px;\">\n      {{menuItem.name}}\n    </a>\n  </clr-vertical-nav>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/admin.component.html
// module id = ./src/app/admin/admin.component.html
// module chunks = main